import { getCart } from '@/apis/header/header.api';
import { getLoginInfoApi } from '@/apis/login/login.api';
import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { UserInfoButtonClient } from './userInfoButtonClient';

interface Props {
  disable?: boolean;
}

const getUserInfo = async () => {
  const [cartResult, [_, userInfoResult]] = await Promise.all([
    getCart({
      verticalTag: 'cn_ybxt_b2c',
      omittedDetail: true,
      cartuuid: cookieUtils.getCookie('VISITOR_UUID'),
      userActionId: 'getCart',
    }),
    getLoginInfoApi({ types: [6] }, { meta: { forceIgnoreLogin: true } }),
  ]);

  // 处理购物车数量
  let cartNum = 0;
  if (cartResult?.success && cartResult?.data) {
    cartNum = Number(
      cartResult.data?.data?.subtotal?.info?.['HJM-D#subtotal&number']?.productNum || '',
    );
  }

  // 处理用户数据
  let userInfo = null;
  if (userInfoResult?.success && userInfoResult?.data) {
    userInfo = userInfoResult.data;
  }

  return {
    cartNum,
    userInfo,
  };
};

const UserInfoButton = async ({ disable = false }: Props) => {
  const { cartNum, userInfo } = await getUserInfo();
  return <UserInfoButtonClient cartNum={cartNum} userInfo={userInfo} disable={disable} />;
};

export default UserInfoButton;
